<template>
  <div class="content">
    <van-nav-bar title="充值记录详情" left-arrow @click-left="$router.go(-1)" fixed />
     <wv-group :title="data.created_at"></wv-group>
    <van-cell-group class="cell">
      <van-cell title="门店" :value="data.shop_name" />
      <van-cell title="卡号" :value="data.card_number" />
      <van-cell class="green" title="充值金额" :value="data.amount" />
      <van-cell class="red" title="充值后余额" :value="data.deposit_amount_after" />
      <van-cell class="s_card"v-if="data.bonus_amount" :title="`赠卡   `+data.bonus_sequence" :value="data.bonus_amount+`(至`+data.bonus_expire+`)`" />
      <van-cell title="实收" :value="data.income_amount" />
      <van-cell title="支付方式" :value="data.get_method_display" />
      <van-cell v-if="data.created_by_name" title="收银" :value="data.created_by_name" />
    </van-cell-group>
  </div>
</template>
<script>
import { getReCharge } from '@/api/login'
export default {
  created() {
    this.fechData()
  },
  name: 'recharge',
  data() {
    return {
      data: {}
    }
  },
  methods: {
    fechData() {
      getReCharge(this.$route.query.code).then(res => {
        this.data = res
      })
    },

  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cell .van-cell {
  padding: 10px 20px;
}
.cell .van-cell__title {
  text-align: left;
  color: #D98719;

}
.s_card .van-cell__title {
  color: #09bb07;
}
.s_card .van-cell__value {
  color:#999 !important;
}
.cell .van-cell__value {
  color: rgb(102, 102, 102);
}

.green .van-cell__value {
  color: #09bb07
}

.red .van-cell__value {
  color: #F56C6C
}

</style>



// WEBPACK FOOTER //
// src/components/cards/recharge.vue